export const LEVEL_NAME = 'detected_level';
export const DEFAULT_URL_COLUMNS = ['timestamp', 'body', 'Time', 'Line'];
